export const ID54 = () => {
    return (
        <div>
            <h1>Кибернетика: Подсистема «Казначейство» для «Бухгалтерии для Казахстана», ред. 3.0</h1>
            Разработчик: ТОО «Кибернетика.com»
            Категория: Дополнение к конфигурациям, разработанные без использования механизма расширений.

            Отрасли: Добывающая промышленность; Нефтяная, газовая промышленность

            Описание: Продукт предназначен для управления статьями финплана и осуществлением контроля за расходованием
            денежных средств в реальном времени.
            Основные функциональные возможности:
            <ul>
                <li>формирование и контроль выплат согласно утвержденному ежедневному реестру платежей (оплат);</li>
                <li>контроль, согласование и связь с документами-основаниями по каждой производимой оплате;</li>
                <li>контроль соответствия платежей условиям договора;</li>
                <li>контроль исполнения статей движения денежных средств;</li>
                <li>планирование и контроль расходования денежных средств;</li>
                <li>подготовка отчетности в автоматическом режиме;</li>
                <li>переключение сотрудников фин. отдела с механической – на аналитическую работу.</li>
            </ul>

            Продукт «Кибернетика: Подсистема «Казначейство» для «Бухгалтерии для Казахстана», ред. 3.0» разработан для
            «Бухгалтерия для Казахстана» системы программ "1С:Предприятие 8" с сохранением всех основных возможностей и
            механизмов данного решения.

            Для работы продукта необходимо наличие установленной платформы «1С:Предприятие 8.3» (не ниже версии 8.3.12).

            Вариант работы: Файловый, клиент – серверный.
            Режим запуска: Управляемое приложение.
        </div>
    )
}